/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.autocomplete.rpc.AcademyAutocompleteChirpService
 */

export const getAutocompleteSuggestionsRpc = {
  serviceName: 'com.hubspot.academy.autocomplete.rpc.AcademyAutocompleteChirpService',
  rpcName: 'getAutocompleteSuggestions',
  auth: 'app',
  fingerprint: 'VVt6TOfQgYcaPP6qSNUBjrdzw5GWQhx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};